import { render, staticRenderFns } from "./AttributeValue.vue?vue&type=template&id=42788678&"
import script from "./AttributeValue.vue?vue&type=script&lang=js&"
export * from "./AttributeValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports